import React, { Component } from 'react'
import { Col, Row, Input, Label } from 'reactstrap'
import ModalForm from '../../../comum/components/ModalForm'
import { observer } from 'mobx-react'
import FormInputSimples from '../../../comum/components/FormInputSimples'
import NovoDirecionamentoStore from '../stores/NovoDirecionamentoStore'
import { IconeFechar } from '../../../comum/components/Icones'
import RadiobuttonGroup from '../../../comum/components/RadiobuttonGroup'
import FormSelectSimples from '../../../comum/components/FormSelectSimples'
import CalendarioPicker from '../../../comum/components/Calendario'
import FormOnlyPositiveNumberSimples from '../../../comum/components/FormNumberSimples'
import { isInvalidoCodigoContainer } from '../../../../utils/validadores'
import CheckboxField from '../../../comum/components/CheckboxField'

@observer
export default class IncluirDirecionamento extends Component {
    
    constructor(props) {
        super(props)

        this.direcController = this.props.controller
        this.controller = new NovoDirecionamentoStore(this.direcController.service)

        this.handleSalvar = this.handleSalvar.bind(this)
        
    }
    
    componentDidMount() {

        if(this.direcController.adicionando && this.direcController.listaAdicoes.length > 0) {
            this.controller.setDadosDirecionamento(this.direcController.dadosAdicao)
        } else {
            this.controller.tipoDoc = "DTC"
        }

        if(this.direcController.editando) {
            this.controller.setDadosEdicao(this.direcController.elementoEmEdicao)
        }
    }

    handleSalvar() {
        this.controller.adicionar = true
        //Tenho que fazer uma variável no store de direcionamento ficar true e abrir a tabela de adições
        //this.direcController.adicionarDirecionamento(this.controller.ceHouse,this.controller.emails,this.controller.codRef,this.controller.listaAnexos)
        if(!this.alerta() && !this.direcController.editando) {
            if(this.direcController.listaAdicoes.length === 0) {
                this.direcController.setDadosEntrada(this.controller.tipoDoc, this.controller.dtAtracacaoInicio, this.controller.dtAtracacaoFim, this.controller.operacao)
            }
            this.direcController.adicionarListaAdicoes(this.controller.tipoDoc,this.controller.flagCarga,this.controller.ceHouse,this.controller.container, this.controller.cnpj,this.controller.razaoSocial, this.controller.operacao,this.controller.listaAnexos)
            this.direcController.mostrarTabelaAdicionar()
            this.direcController.fecharModalAdicionar()
        } else if(!this.alerta() && this.direcController.editando) {
            this.direcController.alterarDadosEdicao(this.controller.ceHouse,this.controller.flagCarga,this.controller.container, this.controller.cnpj,this.controller.razaoSocial,this.controller.listaAnexos)
            this.direcController.fecharEdicao()
        }
    }

    alerta = () => {
        return (
            this.alertaCeHouse() ||
            this.alertaOperacao() ||
            this.alertaRazaoSocial() ||
            this.alertaContainer() ||
            this.alertaCnpj() ||
            this.alertaData() ||
            this.alertaAnexos()
        )
    }

    alertaCeHouse = () => {
        if(this.controller.adicionar && this.controller.ceHouse.length === 0) {
            return "Campo obrigatório"
        } else if(this.controller.adicionar && this.controller.ceHouse.length < 15){
            return "Por favor, insira todos os 15 digitos."
        } else {
            return false
        }
    }

    alertaOperacao = () => {
        if(this.controller.adicionar && this.controller.operacao === null) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaRazaoSocial = () => {
        if(this.controller.adicionar && this.controller.razaoSocial.length === 0) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaContainer = () => {
        if(this.controller.adicionar && this.controller.container.length === 0) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaCnpj = () => {
        if(this.controller.adicionar && this.controller.cnpj.length === 0) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaData = () => {
        if(this.controller.adicionar && (this.controller.dtAtracacaoInicio === null || this.controller.dtAtracacaoFim === null)) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    alertaAnexos = () => {
        if(this.controller.adicionar && this.controller.listaAnexos.length === 0) {
            return "Campo obrigatório"
        } else {
            return false
        }
    }

    render() {
        return (
            <ModalForm
                className="modal-direcionamento"
                labelConfirmar = "CONFIRMAR"
                onClickCancelar = {this.direcController.editando ? this.direcController.fecharEdicao : this.direcController.fecharModalAdicionar}
                onClickSalvar = {this.handleSalvar}
            >
                <h2>
                    {
                        this.direcController.editando
                        ? "Editar direcionamento"
                        : "Novo direcionamento"
                    }
                </h2>
                <Row>
                    <RadiobuttonGroup xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Tipo de documento"
                        name="docType"
                        bloqueado={this.direcController.dadosAdicao.tipoDoc ? true : false}
                        //obrigatorio={true}
                        //alerta={this.alertaDocCntr()}
                        onClick={this.controller.setTipoDoc}
                        itens={[
                            { id: "DTC", value: "DTC", label: "DTC", checked: this.controller.tipoDoc === "DTC" },
                            { id: "DTA", value: "DTA", label: "DTA", checked: this.controller.tipoDoc === "DTA" }
                        ]}
                    />
                    <CheckboxField xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Consolidado - Carga Solta"
                        name="flagCarga"
                        bloqueado={this.controller.tipoDoc !== "DTA"}
                        ativo={this.controller.flagCarga}
                        onClick={() => {
                            this.controller.setFlagCarga(!this.controller.flagCarga);
                        }}
                    />
                </Row>
                <Row>
                    <Col xs={12} sm={12} md={6} lg={6} xl={6} className="mb-4">
                        <Label>Previsão de atracação<span className="label-danger">*</span></Label>
                        <CalendarioPicker 
                            titulo="Previsão de atracação"
                            onChangeInicio={this.controller.setDataInicio}
                            onChangeFim={this.controller.setDataFim}
                            dataInicial={this.controller.dtAtracacaoInicio}
                            dataFinal={this.controller.dtAtracacaoFim}
                            filtrar={this.controller.listarOperacoes}
                            bloqueado={this.direcController.dadosAdicao.dtInicio || this.direcController.dadosAdicao.dtFim ? true : false}
                        />
                        {this.alertaData() && <Label className="label-danger">{ this.alertaData() }</Label>}
                    </Col>
                    <FormSelectSimples  xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Operação"
                        itens={this.controller.operacoes}
                        dado={this.controller.operacao}
                        bloqueado={
                            this.controller.operacoes.length === 0 || 
                            this.controller.dtAtracacaoInicio === null || 
                            this.controller.dtAtracacaoFim === null ||
                            this.controller.loadingOperacoes ||
                            this.direcController.dadosAdicao.operacao !== null
                        }
                        obrigatorio={true}
                        alerta={this.alertaOperacao()}
                        onChange={this.controller.setOperacao}
                    />

                    <FormOnlyPositiveNumberSimples xs={12} sm={12} md={12} lg={12} xl={12}
                        type = "number"
                        titulo="CE House"
                        dado={this.controller.ceHouse}
                        obrigatorio={true}
                        limiteMaximo={15}                      
                        alerta={this.alertaCeHouse()}
                        onChange={(event) => this.controller.setCeHouse(event.target.value)}

                    />

                    <FormInputSimples xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Containers"
                        dado={this.controller.container}
                        obrigatorio={true}
                        alerta={this.alertaContainer()}
                        onChange={(event) => this.controller.setContainer(event.target.value)}
                        extraInfo={"Adicione um ou mais Containers separados por vírgula."}
                    />
                    
                    <FormInputSimples xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="CPF/CNPJ"
                        dado={this.controller.cnpj}
                        obrigatorio={true}
                        alerta={this.alertaCnpj()}
                        onChange={(event) => this.controller.setCnpj(event.target.value)}
                    />

                    <FormInputSimples xs={12} sm={12} md={12} lg={12} xl={12}
                        titulo="Razão social"
                        dado={this.controller.razaoSocial}
                        obrigatorio={true}
                        alerta={this.alertaRazaoSocial()}
                        onChange={(event) => this.controller.setRazaoSocial(event.target.value)}
                    />
                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Label>Anexos<span className="label-danger">*</span></Label>
                        { this.controller.listaAnexos.length > 0
                        ? <Col xs={12} md={12} className="mb-4">{
                            this.controller.listaAnexos.map((item, index) =>
                                <div key={index} className={`item-anexo`}>
                                    <span>{`${item.name}`}</span>
                                    <span className="ml-2">
                                        {/* <Baixar tamanho="lg" className="mr-2" onClick={() => this.controller.baixarAnexo(item.Id, index)} /> */}
                                        <IconeFechar tamanho="lg" onClick={() => this.controller.removerAnexo()} />
                                    </span>
                                </div>
                            )}
                        </Col>
                        : <React.Fragment>
                            <Input className="p-2 mb-4" type="file" onChange={e => this.controller.anexarArquivo(e)} accept=".csv, .xml, .txt, .xls, .xlsx, .doc, .pdf" />
                            {this.alertaAnexos() && <Label className="label-danger">{ this.alertaAnexos() }</Label>}
                        </React.Fragment>
                    }
                    </Col>
                </Row>
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/direcionamento/recinto/components/IncluirDirecionamento.js